export default {
  data() {
    return {
      signedDocuments: {
        mobileDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortSignedDocuments(
                    this.teamsSettings[this.$route.params.team].listsSettings.signedDocuments.order.col,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortSignedDocuments(
                    this.teamsSettings[this.$route.params.team].listsSettings.signedDocuments.order.col,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
          {
            title: this.$t("dropdowns.sortingBy"),
            options: [
              {
                label: this.$t("signedDocuments.orderBy.title"),
                key: "title",
                method: () => {
                  this.sortSignedDocuments(
                    "title",
                    this.teamsSettings[this.$route.params.team].listsSettings.signedDocuments.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("signedDocuments.orderBy.created_at"),
                key: "created_at",
                method: () => {
                  this.sortSignedDocuments(
                    "created_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.signedDocuments.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("signedDocuments.orderBy.expire_at"),
                key: "expire_at",
                method: () => {
                  this.sortSignedDocuments(
                    "expire_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.signedDocuments.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
      },
    };
  },
};
